import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import axios from "axios";
import { API } from "@/lib/api";
import { LEGAL_TEXT, Wordmark } from "@/components/brand/Brand";

export default function Unsubscribe() {
  const [q] = useSearchParams();
  const token = q.get("t") || "";
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const send = (on) => axios.post(`${API}/email/unsubscribe`, { token, on }).then(({ data }) => setD(data)).catch((e) => setErr(e?.response?.data?.detail || "Something went wrong"));
  useEffect(() => { send(false); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-q-base p-6 text-center" data-testid="unsubscribe-page">
      <Wordmark />
      <div className="q-card max-w-md">
        {err ? <p className="text-q-muted" data-testid="unsubscribe-error">{err}</p> : !d ? <Loader2 className="mx-auto h-6 w-6 animate-spin" /> : (
          <>
            <p className="font-display text-xl font-extrabold text-q-text" data-testid="unsubscribe-message">{d.message}</p>
            <p className="mt-1 text-sm text-q-muted" data-testid="unsubscribe-type">{d.label}</p>
            <button className="q-btn q-btn-secondary mt-4" onClick={() => send(!d.on)} data-testid="unsubscribe-toggle-btn">{d.on ? "Turn these emails off" : "Turn them back on"}</button>
          </>
        )}
      </div>
      <p className="max-w-md text-xs text-q-faint">{LEGAL_TEXT}</p>
    </div>
  );
}
